import React, { createContext, useCallback, useState } from 'react';
import { UserType } from '../types';
import { useQueryClient } from 'react-query';
import { CacheKeys } from '../constants';
import { useProfileContext } from '../hooks';
export const AwarenessContext = createContext(undefined);
export const AwarenessContextProvider = ({ children }) => {
    const queryClient = useQueryClient();
    const { profile } = useProfileContext();
    const [conversationAwareness, setConversationAwareness] = useState({});
    const [matchAwareness, setMatchAwareness] = useState({});
    const [focusedConversation, setFocusedConversation] = useState({
        id: null,
        visibility: null
    });
    const timer = (thread, participant) => {
        return setTimeout(() => {
            setConversationAwareness((awareness) => {
                var _a;
                return (Object.assign(Object.assign({}, awareness), { [thread]: Object.assign(Object.assign({}, awareness[thread]), { participants: Object.assign(Object.assign({}, (_a = awareness[thread]) === null || _a === void 0 ? void 0 : _a.participants), { [participant]: { status: 'idle', timer: null } }) }) }));
            });
        }, 5 * 1000);
    };
    const update = useCallback((payload) => {
        const { type, id } = payload;
        switch (type) {
            case 'matching':
                const { numOfPendingMatches } = payload.data;
                setMatchAwareness((cur) => (Object.assign(Object.assign({}, cur), { [id]: numOfPendingMatches })));
                break;
            case 'conversation':
                const { data } = payload;
                setConversationAwareness((awareness) => {
                    var _a;
                    const conversation = awareness[id];
                    const { participants, message } = data;
                    if (participants) {
                        Object.keys(participants).forEach((key) => {
                            var _a, _b;
                            const participant = (_a = conversation === null || conversation === void 0 ? void 0 : conversation.participants) === null || _a === void 0 ? void 0 : _a[key];
                            if (((_b = participants[key]) === null || _b === void 0 ? void 0 : _b.status) && (participant === null || participant === void 0 ? void 0 : participant.timer)) {
                                clearTimeout(participant.timer);
                            }
                        });
                    }
                    return Object.assign(Object.assign({}, awareness), { [id]: Object.assign(Object.assign(Object.assign({}, (conversation !== null && conversation !== void 0 ? conversation : {})), (message ? { message } : {})), (participants
                            ? {
                                participants: Object.keys(participants).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: Object.assign(Object.assign({}, participants[key]), { timer: participants[key].status === 'typing'
                                            ? timer(id, key)
                                            : null }) })), (_a = conversation === null || conversation === void 0 ? void 0 : conversation.participants) !== null && _a !== void 0 ? _a : {})
                            }
                            : {})) });
                });
                break;
            case 'profile':
                if ((profile === null || profile === void 0 ? void 0 : profile.type) === UserType.PARENT ||
                    (profile === null || profile === void 0 ? void 0 : profile.type) === UserType.STUDENT)
                    break;
                queryClient
                    .getQueriesData([CacheKeys.CONVERSATION])
                    .filter(([_, value]) => Boolean(value))
                    .forEach(([key, value]) => {
                    queryClient.setQueryData(key, Object.assign(Object.assign({}, value), { participants: value.participants.map((v) => (Object.assign(Object.assign({}, v), (v.id === payload.id ? payload.data : {})))) }));
                });
                queryClient
                    .getQueriesData([CacheKeys.CONVERSATIONS])
                    .filter(([_, value]) => Boolean(value))
                    .forEach(([key, value]) => {
                    queryClient.setQueryData(key, Object.assign(Object.assign({}, value), { pages: value.pages.map((page) => (Object.assign(Object.assign({}, page), { records: page.records.map((record) => {
                                return Object.assign(Object.assign({}, record), { participants: record.participants.map((v) => (Object.assign(Object.assign({}, v), (v.id === payload.id ? payload.data : {})))) });
                            }) }))) }));
                });
                break;
            default:
                break;
        }
    }, []);
    return (React.createElement(AwarenessContext.Provider, { value: {
            update,
            conversationAwareness,
            matchAwareness,
            focusedConversation,
            setFocusedConversation
        } }, children));
};
//# sourceMappingURL=AwarenessContext.js.map